import React from "react"
import { withRouter } from "react-router-dom"
import { Button } from "antd"
import "./rightForm.scss"
import PropTypes from 'prop-types'


const RightForm = ({ history }) => {
	const handleCreateAccount = () => {
		history.push('/register')
	}

	return (
		<div id="register-form" className="rightForm">
			<div id="registration-form" className="login-form">
				<div className="free-stuff-block">
					<h1>Impulsa tus resultados con una cuenta empresarial</h1>
					<p>
						Registra tu empresa en minutos y accede a una experiencia disenada para crecer:
						gestion centralizada, trazabilidad de operaciones y soporte especializado para
						que tu equipo avance mas rapido y con mayor confianza.
					</p>
				</div>
				<div className="create-account-action">
					<Button
						type="primary"
						className="register-form-button"
						onClick={handleCreateAccount}
					>
            			CREAR CUENTA
					</Button>
				</div>
			</div>
			<div className="white-overlay" />
		</div>
	)
}


RightForm.propTypes = {
	history: PropTypes.object.isRequired
}


export default withRouter(RightForm)
